import React from "react";
import { Section, Link } from "@arp/react-ndbx";
import { Box, Divider, Typography } from "@mui/material";
import { URLS } from "../const/enums";

// ** Payment Contact Details Page */

export const residentialAddress = (
  <>
    <Section>
      <Box>
        <Section align="start">
          <Typography
            sx={{
              width: "fit-content !important",
              lineHeight: "20px",
            }}
            variant="h5"
          >
            Residential address
          </Typography>
        </Section>
        <Section align="start" mt={3}>
          <Typography
            sx={{
              width: "fit-content !important",
            }}
            variant="p3"
          >
            Is the residential address the same as the policy mailing address?
          </Typography>
        </Section>
      </Box>
    </Section>
  </>
);

//----------------------------------------------------------------
//** Opening Script Page */

//** Privacy  Recording Question  */
export const privacyRecordingQuestion = (
  <>
    <Section>
      <Box>
        <Section>
          <Typography
            sx={{
              width: "fit-content !important",
              lineHeight: "20px",
            }}
            variant="p2"
          >
            Before we get started I need to play you some information about{" "}
            <Link
              href={URLS.YOUR_DUTY_EXCLUSION_PRIVACY_NOTICE_URL}
              target="_blank"
            >
              your duty
            </Link>{" "}
            when answering questions during the application process and how we
            collect your personal information. At the end I will ask you to
            confirm that you understand your duty and are happy to proceed. Feel
            free to ask me to clarify anything at the end of the recording. This
            takes about three minutes.
          </Typography>
        </Section>
        <Section mt={3}>
          <Typography
            sx={{
              width: "fit-content !important",
              lineHeight: "20px",
            }}
            variant="p2"
          >
            Is that ok?
          </Typography>
        </Section>
      </Box>
    </Section>
  </>
);

//** play duty and privacy notice recording */
export const playDutyAndPrivacyNoticeRecording = (
  <>
    <Section>
      <Divider />
      <Box>
        <Section mt={5} mb={3}>
          <Typography
            sx={{
              width: "fit-content !important",
              lineHeight: "20px",
            }}
            variant="p2-bold"
          >{`<Instruction: Play Duty and Privacy notice recording>`}</Typography>
        </Section>
        <Section>
          <Typography
            sx={{
              width: "fit-content !important",
              lineHeight: "20px",
            }}
            variant="p2"
          >
            Thank you for listening. To confirm, do you understand it is
            important you do not make a misrepresentation, and agree to how we
            collect your personal information?
          </Typography>
        </Section>
        <Section mt={3}></Section>
      </Box>
    </Section>
  </>
);

//** additional summary Question  */
export const additionalSummaryInstruction = (
  <>
    <Section>
      <Divider />
      <Box>
        <Section mt={5} mb={3}>
          <Typography
            sx={{
              width: "fit-content !important",
              lineHeight: "20px",
            }}
            variant="p2-bold"
          >{`<Instruction: Additional summary of the duty as necessary, and for providing further assistance>`}</Typography>
        </Section>
        <Section>
          <Typography
            sx={{
              width: "fit-content !important",
              lineHeight: "20px",
            }}
            variant="p2"
          >
            {"<"}When answering our questions please think carefully, take the
            time you need and answer honestly, completely and accurately. If you
            make a misrepresentation, this may have an impact on a claim.
          </Typography>
        </Section>
        <Section mt={3}>
          <Typography
            sx={{
              width: "fit-content !important",
              lineHeight: "20px",
            }}
            variant="p2"
          >
            If you are unsure about whether you should include information, or
            if you have difficultly answering our questions please let me know.
            {">"}
          </Typography>
        </Section>
      </Box>
    </Section>
  </>
);

//** no advice warning  */
export const noAdviceWarning = (
  <>
    <Section>
      <Divider />
      <Box>
        <Section mt={5} mb={3}>
          <Typography
            sx={{
              width: "fit-content !important",
              lineHeight: "20px",
            }}
            variant="p2-bold"
          >
            No Advice Warning
          </Typography>
        </Section>
        <Section>
          <Typography
            sx={{
              width: "fit-content !important",
              lineHeight: "20px",
            }}
            variant="p2"
          >
            Can you please confirm that:
          </Typography>
          <Section mt={3}>
            <Typography
              sx={{
                width: "fit-content !important",
                lineHeight: "20px",
              }}
              variant="p2"
            >
              You understand we provide you with factual information only about
              this life insurance cover.
            </Typography>
          </Section>
          <Section mt={3}>
            <Typography
              sx={{
                width: "fit-content !important",
                lineHeight: "20px",
              }}
              variant="p2"
            >
              Irrespective of the content on our website or any other
              information you may have received from us, during all phone calls
              we do not provide any general or personal advice that is intended
              to influence you in deciding about this product or life insurance
              in general.
            </Typography>
          </Section>

          <Section mt={3}>
            <Typography
              sx={{
                width: "fit-content !important",
                lineHeight: "20px",
              }}
              variant="p2"
            >
              We do not take into account your personal circumstances,
              including:
            </Typography>
          </Section>
          <Section mt={2} md={6} align="left">
            <Typography
              sx={{
                width: "fit-content !important",
                lineHeight: "25px",
              }}
              variant="p2"
            >
              <li>your objectives,</li>
              <li>financial situation or needs,</li>
              <li>
                or any information relating to your circumstances that we may
                hold or you may provide us.
              </li>
            </Typography>
          </Section>

          <Section mt={3}>
            <Typography
              sx={{
                width: "fit-content !important",
                lineHeight: "20px",
              }}
              variant="p2"
            >
              If you are unsure, please seek advice from a financial adviser
              before deciding on appropriate insurance cover.
            </Typography>
          </Section>
        </Section>
      </Box>
    </Section>
  </>
);

export const pds = (
  <>
    <Section>
      <Divider />
      <Box>
        <Section mt={5} mb={3}>
          <Typography
            sx={{
              width: "fit-content !important",
              lineHeight: "20px",
            }}
            variant="p2-bold"
          >
            Product Disclosure Statement
          </Typography>
        </Section>
        <Section>
          <Typography
            sx={{
              width: "fit-content !important",
              lineHeight: "20px",
            }}
            variant="p2"
          >
            It is important that you read the Product Disclosure Statement to
            see if this product is right for you. It includes a full description
            of terms, conditions, limits, definitions, exclusions, and waiting
            periods. The PDS and Target Market Determination for this product
            are available online or by calling us.
          </Typography>
        </Section>
        <Section mt={3}>
          <Typography
            sx={{
              width: "fit-content !important",
              lineHeight: "20px",
            }}
            variant="p2"
          >
            Have you had a chance to view the PDS online, or would you like me
            to email this to you now? Shortly, after we issue a policy, a PDS
            will also be sent with the Welcome Pack.
          </Typography>
        </Section>
      </Box>
    </Section>
  </>
);

//** Opt out  marketing Question  */
export const optOutDirectMarketingQuestion = (
  <>
    <Section>
      <Divider />
      <Box>
        <Section mb={1} mt={6}>
          <Typography
            sx={{
              width: "fit-content !important",
              lineHeight: "20px",
            }}
            variant="p2-bold"
          >
            {"<"}Do not read to customer{">"}
          </Typography>
        </Section>
        <Section>
          <Typography
            sx={{
              width: "fit-content !important",
              lineHeight: "20px",
            }}
            variant="p2"
          >
            Has the customer requested to be opted-out of direct marketing?
          </Typography>
        </Section>
      </Box>
    </Section>
  </>
);
